var MobileCarousel = function() {
    return {
        init: function() {
            $('#topnews_carousel').on('init', function() {
                $(this).parent().removeClass('carousel__loading');
            });

            $('#topnews_carousel').slick({
                dots: true,
                infinite: true,
                fade: true,
                prevArrow:"<a href='#!' class='slick-arrow slick-arrow--prev btn btn-light btn--square'><i class='fal fa-angle-left'></i></a>",
                nextArrow:"<a href='#!' class='slick-arrow slick-arrow--next btn btn-light btn--square'><i class='fal fa-angle-right'></i></a>",
                lazyLoad: 'ondemand'
            });

            $('.ii__carousel_strip').each(function() {
                var slidesNbr = $(this).data('slides');

                $(this).slick({
                    dots: true,
                    infinite: true,
                    arrows: false,
                    slidesToShow: slidesNbr + 1,
                    responsive: [
                        {
                            breakpoint: 600,
                            settings: {
                                arrow: false,
                                slidesToShow: slidesNbr,
                                slidesToScroll: 1,
                            },
                        },
                    ],
                });
            });
        }
    };
}();
